module.exports = __webpack_public_path__ + "img/tooth-background.e0b84614.png";